import React, { useCallback, useEffect, useState } from "react";
import ArrowLeftIcon from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import {
  Card,
  Box,
  CardHeader,
  Container,
  Link,
  Stack,
  SvgIcon,
  Typography,
  CardContent,
  Grid,
  TextField,
  Divider,
  Switch,
  Button,
  MenuItem,
} from "@mui/material";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useFormik } from "formik";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  addDoc,
  collection,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { getDownloadURL, getStorage, uploadBytes, ref } from "firebase/storage";
import { FileDropzone } from "../../components/file-dropzone";
import LoadingButton from "@mui/lab/LoadingButton";

type RoomParams = {
  id: string;
};

const firebase = require("firebase/app");

export function PerfilParlamentar() {
  const params = useParams<RoomParams>();
  const roomId = params.id;
  let navigate = useNavigate();

  const [files, setFiles] = useState([]);
  const [parlamentar, setParlamentar] = useState({});
  const [loading, setLoading] = useState(false);

  const legislaturaOptions = [
    {
      label: "Legislatura (2025) - (2028)",
      value: "Legislatura (2025) - (2028)",
    },
    {
      label: "Legislatura (2021) - (2024)",
      value: "Legislatura (2021) - (2024)",
    },
    {
      label: "Legislatura (2017) - (2020)",
      value: "Legislatura (2017) - (2020)",
    },
  ];

  const partidoOptions = [
    { label: "PT - Partido dos Trabalhadores", value: "PT" },
    { label: "MDB - Movimento Democrático Brasileiro", value: "MDB" },
    { label: "PSDB - Partido da Social Democracia Brasileira", value: "PSDB" },
    { label: "PSOL - Partido Socialismo e Liberdade", value: "PSOL" },
    { label: "PSD - Partido Social Democrático", value: "PSD" },
    { label: "PTB - Partido Trabalhista Brasileiro", value: "PTB" },
    { label: "PP - Partido Progressista", value: "PP" },
    { label: "PV - Partido Verde", value: "PV" },
    { label: "PCdoB - Partido Comunista do Brasil", value: "PCdoB" },
    { label: "PRB - Partido Republicano Brasileiro", value: "PRB" },
    { label: "PSC - Partido Social Cristão", value: "PSC" },
    { label: "PDT - Partido Democrático Trabalhista", value: "PDT" },
    { label: "PSB - Partido Socialista Brasileiro", value: "PSB" },
    { label: "PMN - Partido da Mobilização Nacional", value: "PMN" },
    { label: "PRP - Partido Republicano Progressista", value: "PRP" },
    { label: "PRTB - Partido Renovador Trabalhista Brasileiro", value: "PRTB" },
    { label: "PHS - Partido Humanista da Solidariedade", value: "PHS" },
    { label: "PTC - Partido Trabalhista Cristão", value: "PTC" },
    { label: "PR - Partido da República", value: "PR" },
    { label: "PSL - Partido Social Liberal", value: "PSL" },
    { label: "PL - Partido Liberal", value: "PL" },
    { label: "PSDC - Partido Social Democrata Cristão", value: "PSDC" },
    { label: "SOLIDARIEDADE - Partido Solidariedade", value: "SOLIDARIEDADE" },
    { label: "CIDADANIA - Partido Cidadania", value: "CIDADANIA" },
    { label: "UNIAO BRASIL - Partido União Brasil", value: "UNIAO BRASIL" },
    { label: "REPUBLICANOS - Partido Republicanos", value: "REPUBLICANOS" },
    { label: "REDE - Partido Rede", value: "REDE" },
    { label: "UNIAO - Partido União", value: "UNIAO" },
    { label: "NOVO - Partido Novo", value: "NOVO" },
    { label: "PODE - Partido Podemos", value: "PODEMOS" },
  ];

  const statusParlamentarOptions = [
    {
      label: "Ativo",
      value: "ativo",
    },
    {
      label: "Não ativo",
      value: "nao-ativo",
    },
  ];

  const funcoesPartidarias = [
    {
      label: "Presidente",
      value: "presidente",
    },
    {
      label: "Vice-Presidente",
      value: "vice-presidente",
    },
    {
      label: "1º Secretário",
      value: "1-secretário",
    },
    {
      label: "2º Secretário",
      value: "2-secretário",
    },
    {
      label: "Vereador",
      value: "vereador",
    },
    {
      label: "Secretário Geral",
      value: "secretário-geral",
    },
    {
      label: "Coordenador de Comunicação",
      value: "coordenador-comunicação",
    },
    {
      label: "Suplente",
      value: "suplente",
    },
    {
      label: "Mesa Diretora",
      value: "mesa-diretora",
    },
    // Pode adicionar outras funções partidárias conforme necessário
  ];

  const formik = useFormik({
    initialValues: {
      nome: "",
      nomeParlamentar: "",
      telefone: "",
      endereco: "",
      telefoneGabinete: "",
      enderecoGabinete: "",
      legislatura: "",
      partido: "",
      statusParlamentar: "",
      fotoParlamentar: "",
      biografia: "",
      funcaoPartidaria: "",
      cpf: "",
      submit: null,
    },
    validationSchema: Yup.object({
      nome: Yup.string().max(255).required("O campo é obrigatório"),
      nomeParlamentar: Yup.string().max(255).required("O campo é obrigatório"),
      telefone: Yup.string().max(255).required("O campo é obrigatório"),
      endereco: Yup.string().max(255),
      telefoneGabinete: Yup.string().max(255),
      enderecoGabinete: Yup.string().required("O campo é obrigatório"),
      legislatura: Yup.string().max(255),
      partido: Yup.string().max(255),
      biografia: Yup.string().max(255),
      statusParlamentar: Yup.string()
        .max(255)
        .required("O campo é obrigatório"),
      fotoParlamentar: Yup.string().max(255),
      cpf: Yup.string().max(255),
      funcaoPartidaria: Yup.string().max(255).required("O campo é obrigatório"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        setLoading(!loading);

        const db = getFirestore();

        var downloadURL = "";

        const file = files[0];
        const storage = getStorage();

        if (file) {
          try {
            const storageRef = ref(
              storage,
              //@ts-ignore
              "users/belacruz@eleg/files/parlamentares/" + file.name
            );

            // Faça o upload do arquivo
            await uploadBytes(storageRef, file);

            // Obtenha a URL de download do arquivo
            downloadURL = await getDownloadURL(storageRef);
          } catch (error) {
            console.error("Erro durante o upload:", error);
          }
        }

        if (file) {
          const colecaoPaiRef = collection(db, "users");

          const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
          const subcolecaoRef = collection(novoDocumentoRef, "parlamentares");
          const novoDocumento2Ref = doc(subcolecaoRef, `${roomId}`);

          getDoc(novoDocumento2Ref).then((docSnapshot) => {
            if (docSnapshot.exists()) {
              // Acessando os dados do documento
              const documentData = docSnapshot.data();

              // Atualize o campo específico nos dados do documento
              const updatedData = {
                ...documentData,
                parlamentarEstado:
                  values.statusParlamentar !== undefined
                    ? values.statusParlamentar
                    : "",
                biografia:
                  values.biografia !== undefined ? values.biografia : "",
                nomeParlamentar:
                  values.nomeParlamentar !== undefined
                    ? values.nomeParlamentar
                    : "",
                endereco: values.endereco !== undefined ? values.endereco : "",
                enderecoGab:
                  values.enderecoGabinete !== undefined
                    ? values.enderecoGabinete
                    : "",
                imageP: downloadURL,
                cpf: values.cpf !== undefined ? values.cpf : "",
                legislatura:
                  values.legislatura !== undefined ? values.legislatura : "",
                nome: values.nome !== undefined ? values.nome : "",
                partido: values.partido !== undefined ? values.partido : "",
                telefone: values.telefone !== undefined ? values.telefone : "",
                telefoneGab:
                  values.telefoneGabinete !== undefined
                    ? values.telefoneGabinete
                    : "",
                funcaoPartidaria:
                  values.funcaoPartidaria !== undefined
                    ? values.funcaoPartidaria
                    : "",
              };

              // Atualize o documento usando o método `updateDoc`
              return updateDoc(novoDocumento2Ref, updatedData);
            } else {
              throw new Error("O documento não existe!");
            }
          });
        } else {
          const colecaoPaiRef = collection(db, "users");

          const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
          const subcolecaoRef = collection(novoDocumentoRef, "parlamentares");
          const novoDocumento2Ref = doc(subcolecaoRef, `${roomId}`);

          getDoc(novoDocumento2Ref).then((docSnapshot) => {
            if (docSnapshot.exists()) {
              // Acessando os dados do documento
              const documentData = docSnapshot.data();

              // Atualize o campo específico nos dados do documento
              const updatedData = {
                ...documentData,
                parlamentarEstado:
                  values.statusParlamentar !== undefined
                    ? values.statusParlamentar
                    : "",
                biografia:
                  values.biografia !== undefined ? values.biografia : "",
                nomeParlamentar:
                  values.nomeParlamentar !== undefined
                    ? values.nomeParlamentar
                    : "",
                endereco: values.endereco !== undefined ? values.endereco : "",
                enderecoGab:
                  values.enderecoGabinete !== undefined
                    ? values.enderecoGabinete
                    : "",
                cpf: values.cpf !== undefined ? values.cpf : "",
                legislatura:
                  values.legislatura !== undefined ? values.legislatura : "",
                nome: values.nome !== undefined ? values.nome : "",
                partido: values.partido !== undefined ? values.partido : "",
                telefone: values.telefone !== undefined ? values.telefone : "",
                telefoneGab:
                  values.telefoneGabinete !== undefined
                    ? values.telefoneGabinete
                    : "",
                funcaoPartidaria:
                  values.funcaoPartidaria !== undefined
                    ? values.funcaoPartidaria
                    : "",
              };

              // Atualize o documento usando o método `updateDoc`
              return updateDoc(novoDocumento2Ref, updatedData);
            } else {
              throw new Error("O documento não existe!");
            }
          });
        }

        navigate("/");

        helpers.setStatus({ success: true });
        helpers.setSubmitting(false);
        toast.success("Customer updated");
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong!");
        helpers.setStatus({ success: false });
        //@ts-ignore
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  //@ts-ignore
  const handleFilesDrop = useCallback((newFiles) => {
    //@ts-ignore
    setFiles((prevFiles) => {
      return [...prevFiles, ...newFiles];
    });
  }, []);

  //@ts-ignore
  const handleFileRemove = useCallback((file) => {
    setFiles((prevFiles) => {
      //@ts-ignore
      return prevFiles.filter((_file) => _file.path !== file.path);
    });
  }, []);

  const handleFilesRemoveAll = useCallback(() => {
    setFiles([]);
  }, []);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = doc(
      db,
      "users",
      "belacruz@eleg",
      "parlamentares",
      `${roomId}`
    );

    getDoc(ordersRef)
      .then((docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();

          formik.setValues({
            statusParlamentar: data.parlamentarEstado,
            biografia: data.biografia,
            nomeParlamentar: data.nomeParlamentar,
            endereco: data.endereco,
            enderecoGabinete: data.enderecoGab,
            legislatura: data.legislatura,
            nome: data.nome,
            partido: data.partido,
            telefone: data.telefone,
            telefoneGabinete: data.telefoneGab,
            funcaoPartidaria: data.funcaoPartidaria,
            fotoParlamentar: data.imageP,
            cpf: data.cpf,
            submit: null,
          });

          setParlamentar(data);
        } else {
          console.log("Documento não encontrado");
        }
      })
      .catch((error) => {
        console.log("Erro ao recuperar dados do documento:", error);
      });
  }, []);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <NavLink to="/">
                <Link
                  color="text.primary"
                  sx={{
                    alignItems: "center",
                    display: "inline-flex",
                  }}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowLeftIcon />
                  </SvgIcon>
                  <Typography variant="subtitle2">Voltar</Typography>
                </Link>
              </NavLink>
            </div>

            <Stack
              alignItems="flex-start"
              direction={{
                xs: "column",
                md: "row",
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack alignItems="center" direction="row" spacing={2}>
                <Stack spacing={1}>
                  <Typography variant="h4">Editar Parlamentar</Typography>
                </Stack>
              </Stack>
            </Stack>

            <form onSubmit={formik.handleSubmit}>
              <Card>
                <CardContent sx={{ pt: 1 }}>
                  <Grid container justifyContent="space-between">
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={!!(formik.touched.nome && formik.errors.nome)}
                        fullWidth
                        helperText={formik.touched.nome && formik.errors.nome}
                        label="Nome do parlamentar"
                        name="nome"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.nome}
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.nomeParlamentar &&
                            formik.errors.nomeParlamentar
                          )
                        }
                        fullWidth
                        helperText={
                          formik.touched.nomeParlamentar &&
                          formik.errors.nomeParlamentar
                        }
                        label="Apelido do parlamentar"
                        name="nomeParlamentar"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.nomeParlamentar}
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(formik.touched.telefone && formik.errors.telefone)
                        }
                        fullWidth
                        helperText={
                          formik.touched.telefone && formik.errors.telefone
                        }
                        label="Telefone"
                        name="telefone"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.telefone}
                      />
                    </Grid>

                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={!!(formik.touched.cpf && formik.errors.cpf)}
                        fullWidth
                        helperText={formik.touched.cpf && formik.errors.cpf}
                        label="CPF"
                        name="cpf"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.cpf}
                      />
                    </Grid>

                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(formik.touched.endereco && formik.errors.endereco)
                        }
                        fullWidth
                        helperText={
                          formik.touched.endereco && formik.errors.endereco
                        }
                        label="Endereço"
                        name="endereco"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.endereco}
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.telefoneGabinete &&
                            formik.errors.telefoneGabinete
                          )
                        }
                        fullWidth
                        helperText={
                          formik.touched.telefoneGabinete &&
                          formik.errors.telefoneGabinete
                        }
                        label="Telefone do Gabinete"
                        name="telefoneGabinete"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.telefoneGabinete}
                        type="number"
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.enderecoGabinete &&
                            formik.errors.enderecoGabinete
                          )
                        }
                        fullWidth
                        helperText={
                          formik.touched.enderecoGabinete &&
                          formik.errors.enderecoGabinete
                        }
                        label="Endereço do Gabinete"
                        name="enderecoGabinete"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.enderecoGabinete}
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.legislatura &&
                            formik.errors.legislatura
                          )
                        }
                        fullWidth
                        label="Legislatura"
                        name="legislatura"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.legislatura}
                      >
                        {legislaturaOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(formik.touched.partido && formik.errors.partido)
                        }
                        fullWidth
                        label="Partido"
                        name="partido"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.partido}
                      >
                        {partidoOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.statusParlamentar &&
                            formik.errors.statusParlamentar
                          )
                        }
                        fullWidth
                        label="Status do Parlamentar"
                        name="statusParlamentar"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.statusParlamentar}
                      >
                        {statusParlamentarOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.biografia && formik.errors.biografia
                          )
                        }
                        fullWidth
                        helperText={
                          formik.touched.biografia && formik.errors.biografia
                        }
                        label="Biografia"
                        multiline
                        name="biografia"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.biografia}
                      />
                    </Grid>
                    <Grid marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.funcaoPartidaria &&
                            formik.errors.funcaoPartidaria
                          )
                        }
                        fullWidth
                        label="Funções partidárias"
                        name="funcaoPartidaria"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.funcaoPartidaria}
                      >
                        {funcoesPartidarias.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} padding={3} mt={1}>
                    <Grid xs={12} md={12} my={2}>
                      <Stack spacing={1}>
                        <Typography variant="h6">
                          Adicione a foto do parlamentar
                        </Typography>
                        <Typography color="text.secondary" variant="body2">
                          Esta foto será ixibida no tablets.
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid xs={12} md={12}>
                      <FileDropzone
                        accept={{ "image/*": [] }}
                        caption="( Só é permitido 1 arquivo )"
                        files={files}
                        maxFiles={1}
                        disabled={files.length !== 0 ? true : false}
                        onDrop={handleFilesDrop}
                        onRemove={handleFileRemove}
                        onRemoveAll={handleFilesRemoveAll}
                      />
                    </Grid>
                  </Grid>
                </CardContent>

                <Stack
                  direction={{
                    xs: "column",
                    sm: "row",
                  }}
                  flexWrap="wrap"
                  spacing={3}
                  sx={{ p: 3 }}
                >
                  <LoadingButton
                    loading={loading}
                    disabled={formik.isSubmitting}
                    type="submit"
                    variant="contained"
                  >
                    Salvar
                  </LoadingButton>
                  <Button
                    color="inherit"
                    onClick={() => {
                      navigate("/");
                    }}
                    disabled={formik.isSubmitting}
                  >
                    Cancelar
                  </Button>
                </Stack>
              </Card>
            </form>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
